
interface EmptyTabContentProps {
  message: string;
}

const EmptyTabContent = ({ message }: EmptyTabContentProps) => {
  return (
    <div className="text-center text-muted-foreground py-12">
      {message}
    </div>
  );
};

export default EmptyTabContent;
